<!--  -->
<template>
  <div>
    <ul class="lit03">
      <li v-for="item in devicenav" :key="item.title">
        <div class="cont_r_b04">
          <div class="cont_r_b05">
            <img :src="item.img" width="158" height="109">
          </div>
          <div class="cont_r_b06">
            <div class="cont_r_b07">
              <p></p>
            </div>
            <div class="cont_r_b09">
              <p></p>
              <p>
                <span style="font-family:&quot;color:black;">
                  <strong>
                    <u>{{item.title}}</u>
                  </strong>
                </span>
              </p>
              <p>
                <span style="font-family:&quot;color:black;">
                  <span></span>
                </span>
                <span style="font-family:&quot;color:black;">
                  <br>
                </span>
              </p>
              <p style="font-family:&quot;color:black;" v-html="item.word"></p>
              <p></p>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      devicenav: [
        {
          title: "Комплект оборудования",
          word:
            "Линия непрерывной разливки и прокатки алюминиевых прутков<br />Линия непрерывной разливки и прокатки медных труб<br />Линия производства арматуры",
          img: require("../../../assets/img/common/home7.jpg")
        },
        {
          title: "Оборудование для обработки цветных металлов",
          word:
            "Барабан кассетного волочения<br />Машина послойной бухтосвертки<br />Планетарный прокатный стан<br />Многороликовый прокатный стан<br />Комбинированная волочильная линия<br />Экструдер в сборе<br />Колпаковая печь для отжиг<br />Печь для непрерывных отжиг",
          img: require("../../../assets/img/common/home8.jpg")
        },
        {
          title: "Оборудование для экструзии и литья пластмасс",
          word:
            "Экструдер для пластмассы<br />Экструзионная форма<br />Форма для литья под давлением<br />Шнек и цилиндр",
          img: require("../../../assets/img/common/home9.jpg")
        },
        {
          title: "Оборудование для обработки черных металлов",
          word:
            "Многороликовый сталепрокатный стан<br />Оборудование для непрерывной разливки стали",
          img: require("../../../assets/img/common/home10.jpg")
        }
      ]
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/ew/device/devicesy.vue